module.exports = __webpack_public_path__ + "fonts/backbone-icons.a30c9e1e.ttf";